import { history } from '../_helpers'
import { toastr } from 'react-redux-toastr'

export function handleSuccess(response) {
  return { data: response.data }
}

export function handleError(error) {
  if (error.message === 'Network Error') {
    // The user doesn't have internet
    toastr.info('مشکلی پیش آمد', 'ارتباط با سرور برقرار نیست')
    return Promise.reject(error)
  }
  switch (error.response.status) {
    // case 400:
    // toastr.info('مشکلی پیش آمد', 'سرور قادر به تشخیص درخواست شما نمی‌ باشد.');
    // break;
    case 401:
      toastr.info(
        'دسترسی نا معتبر',
        'مدت زمان استفاده شما از سیستم به پایان رسیده است. لطفا اطلاعات کاربری خود را دوباره وارد کنید.'
      )
      history.push(`/login`, null)
      console.log('axios')
      break
    case 404:
      // Show 404 page
      toastr.info('مشکلی پیش آمد', 'پاسخی برای درخواست شما یافت نشد')
      break
    case 500:
      // Serveur Error redirect to 500
      toastr.info('مشکلی پیش آمد', 'خطای داخلی سرور')
      break
    default:
      // Unknow Error
      break
  }
  return Promise.reject(error)
}
